var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.08 19.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    "data-name": "Capa 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.55,4.04c.33-.33.53-.8.53-1.27s-.19-.93-.53-1.27l-.98-.98c-.33-.33-.8-.53-1.27-.53s-.93.19-1.27.53L2.2,13.36l-2.2,5.03v.68h12.31c.51,0,.92-.41.92-.92s-.41-.92-.92-.92h-2.15c-.17,0-.31-.14-.31-.31s.14-.31.31-.31h7.08v-.62h-7.08c-.51,0-.92.41-.92.92s.41.92.92.92h2.15c.17,0,.31.14.31.31s-.14.31-.31.31H2.09l3.63-1.59,12.84-12.84ZM15.1,6.62l-.49.49-2.64-2.64.49-.49,2.64,2.64ZM12.9,3.54l.49-.49,2.64,2.64-.49.49-2.64-2.64ZM12.18,5.54L3.54,14.18l-.64-.64L11.54,4.9l.64.64ZM12.61,5.97l.49.49L4.46,15.1l-.49-.49L12.61,5.97ZM13.54,6.9l.64.64-8.64,8.64-.64-.64L13.54,6.9ZM15.47.96c.22-.22.52-.34.83-.34s.61.13.83.34l.98.98c.22.22.34.52.34.83s-.13.61-.34.83l-1.65,1.65-2.64-2.64,1.65-1.65ZM2.56,14.07l2.44,2.44-2.39,1.05-1.09-1.09,1.05-2.39ZM1.25,17.07l.75.75-1.34.59.59-1.34Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditar);
export default __webpack_public_path__ + "static/media/Editar.695bbbae4a99e07ce4ae99001d2e1b6b.svg";
export { ForwardRef as ReactComponent };